module.exports = __webpack_public_path__ + "static/map_ubicacion-e6ec86ede43ad6cfcb87f2314e841a47.jpg";